import * as actionTypes from '../actions/actionTypes';

const initialState = {
    token: localStorage.getItem('token'),
    addChatError:null,
    getChatError:null,
    payload:[],

};

const chatroomReducer = (state = initialState, action) => {
    // console.log('action caseInformationReducer action: '+JSON.stringify(action))
    switch (action.type) {
        case actionTypes.ADD_Chat_MSG:
            return {
                ...state,
                payload: [...state.payload, '{username:'+action.username+',content:<p>'+action.content+'</p>,timestamp:<p>'+action.timestamp+'</p>}'],
                addChatError:false,
                getChatError:false,
            };
        case actionTypes.Error_ADD_Chat_MSG:
            return {
                ...state,
                addChatError: action.addChatError,
            };
        case actionTypes.ERROR_GET_ALL_CHAT_MSG:
            return {
                ...state,
                getChatError: action.getChatError,
            };
        case actionTypes.GET_ALL_CHAT_MSGS:
            return {
                ...state,
                payload: action.payload,
                addChatError:false,
                getChatError:false,
            };
        default:
            return state;
    }
};

export default chatroomReducer;